// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});




/*
  Tatwa - Lire la suite / Réduire pour texte éditorial collection
  Version ciblée : uniquement le troisième bloc Rich Text

  Objectif :
  Améliorer l’UX mobile des textes éditoriaux SEO des pages collections,
  en repliant uniquement le second bloc éditorial situé avant la FAQ.

  Logique :
  - Le premier bloc Rich Text correspond généralement à la description courte en haut de page
  - Le deuxième bloc Rich Text correspond au premier bloc éditorial
  - Le troisième bloc Rich Text correspond au second bloc éditorial à replier sur mobile
  - Le bouton est injecté uniquement sous ce troisième bloc
  - Le CSS applique le repli uniquement sur mobile

  Important SEO :
  Le contenu reste présent dans le DOM.
  Il n’est pas supprimé, ni masqué en display:none.
*/

(function () {
  var SELECTOR = '.rich-text__text.rte.section-blocks__subheading';
  var MIN_TEXT_LENGTH = 100;

  function initTatwaReadMore() {
    var blocks = document.querySelectorAll(SELECTOR);

    /*
      On ignore :
      - blocks[0] : description courte en haut de page
      - blocks[1] : premier bloc éditorial

      On cible :
      - blocks[2] : second bloc éditorial avant la FAQ
    */
    if (blocks.length < 3) return;

    var block = blocks[2];
    var index = 2;

    if (block.dataset.tatwaReadmoreInit === '1') return;

    var textLength = block.textContent.trim().length;

    if (textLength < MIN_TEXT_LENGTH) return;

    block.dataset.tatwaReadmoreInit = '1';

    if (!block.id) {
      block.id = 'tatwa-readmore-content-' + index;
    }

    block.classList.add('tatwa-readmore-content');
    block.classList.add('tatwa-readmore-is-collapsed');

    var wrap = document.createElement('div');
    wrap.className = 'tatwa-readmore-wrap';

    var moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'tatwa-readmore-btn tatwa-readmore-btn--more';
    moreBtn.textContent = 'Lire la suite';
    moreBtn.setAttribute('aria-expanded', 'false');
    moreBtn.setAttribute('aria-controls', block.id);

    var lessBtn = document.createElement('button');
    lessBtn.type = 'button';
    lessBtn.className = 'tatwa-readmore-btn tatwa-readmore-btn--less tatwa-hidden';
    lessBtn.textContent = 'Réduire';
    lessBtn.setAttribute('aria-expanded', 'true');
    lessBtn.setAttribute('aria-controls', block.id);

    wrap.appendChild(moreBtn);
    wrap.appendChild(lessBtn);

    block.insertAdjacentElement('afterend', wrap);

    moreBtn.addEventListener('click', function () {
      block.classList.remove('tatwa-readmore-is-collapsed');
      moreBtn.classList.add('tatwa-hidden');
      lessBtn.classList.remove('tatwa-hidden');
      moreBtn.setAttribute('aria-expanded', 'true');
    });

    lessBtn.addEventListener('click', function () {
      block.classList.add('tatwa-readmore-is-collapsed');
      lessBtn.classList.add('tatwa-hidden');
      moreBtn.classList.remove('tatwa-hidden');
      moreBtn.setAttribute('aria-expanded', 'false');

      block.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

  function launchTatwaReadMore() {
    initTatwaReadMore();
    setTimeout(initTatwaReadMore, 300);
    setTimeout(initTatwaReadMore, 800);
    setTimeout(initTatwaReadMore, 1500);
    setTimeout(initTatwaReadMore, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', launchTatwaReadMore);
  } else {
    launchTatwaReadMore();
  }

  window.addEventListener('load', launchTatwaReadMore);
  document.addEventListener('shopify:section:load', launchTatwaReadMore);
})();




/*
  Tatwa - FAQ accordéon : une seule réponse ouverte à la fois
  Objectif :
  Lorsqu'une FAQ est ouverte, toutes les autres FAQ de la même section
  se ferment automatiquement.

  Compatible avec la section Shopify :
  .collapsible-row-list
*/

(function () {
  function closeFaqItem(item) {
    if (!item) return;

    var trigger = item.querySelector('.collapsible-row-list-item__trigger');
    var panel = item.querySelector('.collapsible-row-list-item__text-container');

    item.setAttribute('data-open', 'false');
    item.classList.remove('active', 'is-active', 'is-open', 'open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('active', 'is-active', 'is-open', 'open');
    }

    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.style.display = 'none';
      panel.classList.remove('active', 'is-active', 'is-open', 'open');
    }
  }

  function closeOtherFaqItems(activeItem) {
    if (!activeItem) return;

    var section = activeItem.closest('.collapsible-row-list');
    if (!section) return;

    var items = section.querySelectorAll('.collapsible-row-list-item');

    items.forEach(function (item) {
      if (item !== activeItem) {
        closeFaqItem(item);
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.collapsible-row-list-item__trigger');

      if (!trigger) return;

      var activeItem = trigger.closest('.collapsible-row-list-item');

      if (!activeItem) return;

      /*
        On ferme les autres FAQ avant l'action native du thème.
        Le thème peut ensuite ouvrir ou fermer normalement l'item cliqué.
      */
      closeOtherFaqItems(activeItem);

      /*
        Sécurité : on relance juste après l'action native du thème,
        au cas où celui-ci réapplique des états après le clic.
      */
      setTimeout(function () {
        closeOtherFaqItems(activeItem);
      }, 120);
    },
    true
  );
})();


/*
  Tatwa - Classe body pour styles spécifiques pages collections
  Objectif :
  Activer certains styles uniquement sur les URLs /collections
*/

(function () {
  function addTatwaCollectionClass() {
    if (window.location.pathname.indexOf('/collections') === 0) {
      document.body.classList.add('tatwa-collection-page');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addTatwaCollectionClass);
  } else {
    addTatwaCollectionClass();
  }
})();